import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FadeInSection from '@/components/feature/FadeInSection';
import SeoHead from '@/components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const privacyJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  url: `${SITE_URL}/privacy`,
  name: 'プライバシーポリシー | 縁結び 和はは',
  description: '東京のシニア婚活相談所「縁結び和はは」のプライバシーポリシー。個人情報の取り扱いについてご説明します。',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: 'プライバシーポリシー', item: `${SITE_URL}/privacy` },
    ],
  },
};

const sections = [
  {
    title: '1. 個人情報の収集について',
    content: `当社は、以下の場合に個人情報を収集することがあります。

・お問い合わせフォームからのご連絡時
・無料相談のご予約時
・入会手続き時
・LINEやメールでのご連絡時

収集する個人情報には、お名前、年齢、性別、電話番号、メールアドレス、その他ご相談内容が含まれます。`,
  },
  {
    title: '2. 個人情報の利用目的',
    content: `収集した個人情報は、以下の目的のために利用いたします。

・お問い合わせへの返答・ご連絡
・無料相談のご予約確認・調整
・婚活サービスのご提供
・サービスに関するご案内・情報提供
・サービス改善のための統計的分析（個人を特定しない形で使用）

上記以外の目的で個人情報を利用する場合は、事前にご本人の同意を得るものとします。`,
  },
  {
    title: '3. 個人情報の第三者提供',
    content: `当社は、以下の場合を除き、収集した個人情報を第三者に提供・開示することはありません。

・ご本人の同意がある場合
・法令に基づき開示が必要な場合
・人の生命、身体または財産の保護のために必要な場合
・公衆衛生の向上または児童の健全な育成の推進のために特に必要な場合

なお、お相手のご紹介にあたっては、ご本人の同意のもと、必要な範囲でお相手の情報をご提供する場合があります。`,
  },
  {
    title: '4. 個人情報の管理・保護',
    content: `当社は、収集した個人情報の漏洩、滅失、毀損の防止のために、適切なセキュリティ対策を実施いたします。

・個人情報へのアクセスは、業務上必要な担当者に限定しています
・個人情報を取り扱う担当者に対して、適切な教育・指導を行っています
・不要になった個人情報は、適切な方法で廃棄・削除いたします`,
  },
  {
    title: '5. 個人情報の開示・訂正・削除',
    content: `ご本人から個人情報の開示、訂正、削除のご要望があった場合は、ご本人であることを確認のうえ、合理的な期間内に対応いたします。

ご要望は、下記のお問い合わせ先までご連絡ください。なお、法令の規定により開示できない場合や、業務上支障をきたす場合はお断りすることがあります。`,
  },
  {
    title: '6. Cookieの使用について',
    content: `当サイトでは、サービス向上のためにCookieを使用することがあります。Cookieとは、ウェブサイトがお客様のブラウザに送信する小さなデータファイルです。

Cookieによって収集される情報は、個人を特定するものではなく、サイトの利用状況の分析やサービス改善のために使用されます。ブラウザの設定によりCookieを無効にすることも可能ですが、一部のサービスが正常に機能しない場合があります。`,
  },
  {
    title: '7. アクセス解析ツールについて',
    content: `当サイトでは、Googleアナリティクス等のアクセス解析ツールを使用することがあります。これらのツールはCookieを使用してデータを収集しますが、個人を特定する情報は含まれません。

収集されたデータはGoogleのプライバシーポリシーに基づいて管理されます。`,
  },
  {
    title: '8. プライバシーポリシーの変更',
    content: `当社は、法令の変更やサービス内容の変更に伴い、本プライバシーポリシーを予告なく変更することがあります。変更後のプライバシーポリシーは、当サイトに掲載した時点から効力を生じるものとします。

重要な変更がある場合は、サイト上でお知らせいたします。`,
  },
  {
    title: '9. お問い合わせ',
    content: `個人情報の取り扱いに関するお問い合わせは、下記までご連絡ください。

事業者名：縁結び 和はは
電話番号：03-4500-8399
受付時間：10:00〜18:00（土日祝を除く）
お問い合わせフォーム：本サイトのお問い合わせページよりご連絡ください`,
  },
];

export default function PrivacyPage() {
  return (
    <>
      <SeoHead
        title="プライバシーポリシー | 縁結び 和はは"
        description="縁結び和ははのプライバシーポリシー。個人情報の取り扱いについてご説明します。"
        path="/privacy"
        jsonLd={privacyJsonLd}
      />
      <Navbar />
      <main>
        {/* Hero */}
        <section
          className="pt-32 pb-16"
          style={{ background: 'linear-gradient(135deg, #fff8f2 0%, #f2f8f4 100%)' }}
        >
          <div className="content-width text-center">
            <FadeInSection>
              <p
                className="inline-block px-4 py-1 rounded-full mb-5 text-sm font-bold"
                style={{ background: '#fff', color: '#5a9e6f', border: '1px solid #5a9e6f' }}
              >
                Privacy Policy
              </p>
              <h1 style={{ color: '#4a3728', fontSize: '36px', fontWeight: '700' }}>
                プライバシーポリシー
              </h1>
              <p className="mt-4" style={{ color: '#6b5a4e', fontSize: '16px' }}>
                最終更新日：2024年4月1日
              </p>
            </FadeInSection>
          </div>
        </section>

        {/* Content */}
        <section className="section-padding" style={{ background: '#fff' }}>
          <div className="content-width">
            <div className="max-w-3xl mx-auto">
              {/* Intro */}
              <FadeInSection>
                <div
                  className="rounded-2xl p-8 mb-12"
                  style={{ background: '#fff8f2', border: '1px solid #e8d8cc' }}
                >
                  <p style={{ color: '#4a3728', fontSize: '16px', lineHeight: '2.0' }}>
                    縁結び 和はは（以下「当社」）は、お客様の個人情報の保護を重要な責務と考え、個人情報の保護に関する法律（個人情報保護法）をはじめとする関連法令を遵守し、お客様の個人情報を適切に取り扱います。本プライバシーポリシーは、当社が提供するサービスにおける個人情報の取り扱いについて定めたものです。
                  </p>
                </div>
              </FadeInSection>

              {/* Sections */}
              <div className="space-y-10">
                {sections.map((section, i) => (
                  <FadeInSection key={i}>
                    <div
                      className="rounded-2xl p-8"
                      style={{ background: '#fafafa', border: '1px solid #e8d8cc' }}
                    >
                      <h2
                        className="mb-5 pb-4"
                        style={{
                          color: '#4a3728',
                          fontSize: '19px',
                          fontWeight: '700',
                          borderBottom: '2px solid #e8934e',
                        }}
                      >
                        {section.title}
                      </h2>
                      <p
                        style={{
                          color: '#5a4a3e',
                          fontSize: '15px',
                          lineHeight: '2.0',
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {section.content}
                      </p>
                    </div>
                  </FadeInSection>
                ))}
              </div>

              {/* Back to contact */}
              <FadeInSection>
                <div className="mt-14 text-center">
                  <Link
                    to="/contact"
                    className="inline-flex items-center gap-2 px-8 py-4 rounded-lg font-bold whitespace-nowrap hover:opacity-90 transition-opacity"
                    style={{ background: '#8b4513', color: '#fff', fontSize: '16px' }}
                  >
                    <i className="ri-arrow-left-line"></i>
                    お問い合わせページへ戻る
                  </Link>
                </div>
              </FadeInSection>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
